<ng-container *ngIf="dateFrom || dateTo">
<span>
    <ng-container [ngSwitch]="!!dateFrom">
      <ng-container *ngSwitchCase="true">
        {{dateFrom | date:'shortDate'}}
      </ng-container>
      <ng-container *ngSwitchDefault>...</ng-container>
    </ng-container>
  </span>
  <span> - </span>
  <span>
    <ng-container [ngSwitch]="!!dateTo">
      <ng-container *ngSwitchCase="true">
        {{dateTo | date:'shortDate'}}
      </ng-container>
      <ng-container *ngSwitchDefault>...</ng-container>
    </ng-container>
  </span>
</ng-container>
